import { useCallback, useState } from 'react';
import CustomFieldsService from '../../../service/customFieldsService';

export const useCustomFields = (selectedRecordType) => {
  const [customFields, setCustomFields] = useState([]);

  const fetchCustomFields = useCallback(async () => {
    if (!selectedRecordType) return;

    try {
      const fields = await CustomFieldsService.getCustomFields(
        selectedRecordType
      );
      setCustomFields(fields?.data?.data || []);
    } catch (error) {
      console.error('Erro ao buscar campos customizados:', error);
      setCustomFields([]);
    }
  }, [selectedRecordType]);

  return { customFields, fetchCustomFields };
};
